
import { Component, Vue } from 'vue-property-decorator';

import * as StatServices from '@/services/StatServices';

@Component
export default class VisitorsPerMonthChart extends Vue {
  loading = false;

  series = [] as any[];
  chartOptions = {
    chart: {
      type: 'bar',
      height: 350
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        endingShape: 'rounded'
      },
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    xaxis: {
      categories: ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct'],
    },
    yaxis: {
      title: {
        text: '# Bezoekers'
      }
    },
    fill: {
      opacity: 1
    },
  }

  async mounted() {
    this.loading = true;
    const data = await StatServices.CountVisitorsPerMonth();
    this.series = [
      {
        name: 'Bezoekers per maand',
        data: data.map((e: any) => e.count)
      }
    ]

    this.chartOptions = {
      ...this.chartOptions,
      xaxis: {
        categories: data.map((e: any) => e.formattedDate)
      }
    }
    this.loading = false;
    this.$emit('loaded');
  }
}
